
//MUI
import CreateIcon from '@mui/icons-material/Create';

//selectors for redux :
import { useDispatch } from "react-redux";
import { shoppingStepSlice } from "../../store/shoppingStepSlice.js";
import { contratStepSlice } from "../../store/contratStepSlice.js";


function RecapStep({ step, infos, custom }) { // component to manage the first step of shopping : choosing place and time

    const dispatch = useDispatch();

    function handlePenClick() {
        dispatch(shoppingStepSlice.actions.goToShoppingStep(step));
        //ManagerMode
        dispatch(contratStepSlice.actions.goToContratStep(step));

    }

    return (
        <div className="recap-step">

            <div className="recap-step-left">
                <div className="recap-step-number">
                    <h2>{step}</h2>
                </div>
                {infos /* component sent as prop */}
            </div>

            <div className="recap-step-right">
                {custom /* component sent as prop */}
                <CreateIcon className="pen-icon" onClick={handlePenClick} />
            </div>
        </div>

    )
}




export default RecapStep